import { render, staticRenderFns } from "./PageResetPassword.vue?vue&type=template&id=eb105638&scoped=true&"
import script from "./PageResetPassword.vue?vue&type=script&lang=js&"
export * from "./PageResetPassword.vue?vue&type=script&lang=js&"
import style0 from "./PageResetPassword.vue?vue&type=style&index=0&id=eb105638&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb105638",
  null
  
)

export default component.exports